import AbsAuthorization from 'core/Authorization/manager';

export class OrderAuthorization extends AbsAuthorization {
	constructor(profile) {
		super(profile);
	}

	checkEditOrderWarranty() {
		return !!this.roles[this.checkOrderL2Manager()];
	}

	checkEditOrderEvent() {
		return !!this.roles[this.checkOrderEventL1Manager()];
	}

	checkEditOrderUser() {
		return !!this.roles[this.checkOrderEventL1Manager()];
	}

	checkEditOrderService() {
		return !!this.roles[this.checkOrderServiceL3Manager()];
	}
}

export default OrderAuthorization;
